import { useLocation } from 'react-router-dom';

export function AccountStatus() {
  const location = useLocation();
  const { title, message, email } = (location.state || {}) as {
    title?: string;
    message?: string;
    email?: string;
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>{title || 'Account'}</h2>
      <p>{message || 'No message available.'}</p>

      {email && (
        <p>
          Support Email: <strong>{email}</strong>
        </p>
      )}
    </div>
  );
}
